import Vue from "vue";
import i18n from "../i18n";

export default {
    namespaced: true,
    state: {
        categories: [],
        categoriesLanguage: ""
    },
    getters: {
        categories(state) {
            return state.categories;
        },
        categoriesLanguage(state) {
            return state.categoriesLanguage;
        }
    },
    mutations: {
        categories(state, categories) {
            state.categories = categories;
        },
        categoriesLanguage(state, categoriesLanguage) {
            state.categoriesLanguage = categoriesLanguage;
        }
    },
    actions: {
        categories() {
            return new Promise((resolve, reject) => {
                let categories = this.getters["shop/categories"];
                let categoriesLanguage = this.getters[
                    "shop/categoriesLanguage"
                ];

                let lang = i18n.locale;
                if (categories.length > 0 && categoriesLanguage === lang) {
                    resolve(categories);
                    return;
                }

                Vue.http
                    .get("api/v1/categories?language=" + lang)
                    .then(response => {
                        this.commit("shop/categories", response.body);
                        this.commit("shop/categoriesLanguage", lang);
                        resolve(response.body);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
};
